// Summarize the warehouse situation across a set of lines into a single
// header-level label.
//
// - All lines share the same locationId → that warehouse's code/name.
// - More than one distinct warehouse, or some assigned + some not → "Múltiples".
// - No line has a warehouse assigned → "Sin almacén".
export function summarizeWarehouse(lines, locationsById) {
  if (!lines || lines.length === 0) return null;

  const ids = new Set();
  let hasUnassigned = false;
  for (const line of lines) {
    if (line.locationId) ids.add(line.locationId);
    else hasUnassigned = true;
  }

  if (ids.size === 0) {
    return { kind: "none", label: "Sin almacén" };
  }
  if (ids.size === 1 && !hasUnassigned) {
    const id = [...ids][0];
    const loc = locationsById?.[id];
    const label = loc?.code || loc?.displayName || loc?.name || "Almacén";
    return { kind: "single", label };
  }
  return { kind: "multiple", label: "Múltiples" };
}
